// modules/LandSearch.js
import React       from 'react';
import LFSSButton  from '../common/LFSSButton';
import MultiSlider from "multi-slider";
import $           from 'jquery';
import LFSConstants from './LFSConstants'
import CloseButton from '../common/CloseButton';
import OrderingButton from '../common/OrderingButton';
import DisplayAllLots from '../common/DisplayAllLots';
import Clr         from '../common/Clr';



class LandSearch extends React.Component {
	constructor(props) {
		super(props);

		var d = new Date();
		this.masterplan_url = "https://interactive-edge-182603.appspot.com/allavailablelots?ts=" + d.getTime();

		this.state = {
			search: {
			},
			sliders: {
				frontage: {
					start: 0,
					middle: 100,
					end: 0
				},
				area: {
					start: 0,
					middle: 100,
					end: 0
				},
			},
			displaysearchresults: false,
			filterby: {
				type: 'frontage',
				order: 'asc',
			},
			filteredlots: null,
			stages: {}
		};


		this.onSliderChangeArea = this.onSliderChangeArea.bind(this);
		this.onSliderChangeFrontage = this.onSliderChangeFrontage.bind(this);
		this.calcNewSliderValues = this.calcNewSliderValues.bind(this);

		this.sliderPositionFormula = this.sliderPositionFormula.bind(this);
		this.sliderValueFormula = this.sliderValueFormula.bind(this);
		this.sliderSearchClick = this.sliderSearchClick.bind(this);

		this.searchLots = this.searchLots.bind(this);
		this.applyLotOrdering = this.applyLotOrdering.bind(this);
		this.ascAreaCompare = this.ascAreaCompare.bind(this);

		this.descAreaCompare = this.descAreaCompare.bind(this);
		this.ascFrontageCompare = this.ascFrontageCompare.bind(this);
		this.descFrontageCompare = this.descFrontageCompare.bind(this);

		this.sliderResetClick = this.sliderResetClick.bind(this);
		this.receivedMasterplanData = this.receivedMasterplanData.bind(this);
		this.updateWithAvailableLots = this.updateWithAvailableLots.bind(this);

		this.onClose = this.onClose.bind(this);
		this.onOrderFrontage = this.onOrderFrontage.bind(this);
		this.onOrderArea = this.onOrderArea.bind(this);

		this.ascPriceCompare = this.ascPriceCompare.bind(this);
		this.descPriceCompare = this.descPriceCompare.bind(this);
		this.onOrderPrice = this.onOrderPrice.bind(this);



	}

	componentDidMount() {
		$.ajax({url:this.masterplan_url,dataType:'json'}).done(this.receivedMasterplanData);
	}


	receivedMasterplanData(data, status, xhr) {
		if(typeof data.lots === 'undefined') data.lots = [];
		if(typeof data.search === 'undefined') data.search = [];

		let newState = Object.assign(this.state, {
			search: data.search,
			stages: data.lots
		});
		this.setState(newState);
	}

	onSliderChangeArea(key) {
		// do our calculations to work out our new positions
		let newPos = this.calcNewSliderValues(key, this.state.search.area);
		// create a new object for the search element

		let searchchg = this.state.search;
		searchchg.area = {
			current : { low : newPos.search.low, high : newPos.search.high, },
			original : this.state.search.area.original,
			step : this.state.search.area.step,
		};

		// create a new object for the slider element
		let sliderchg = this.state.sliders;
		sliderchg.area = { start: newPos.slider.start, middle: newPos.slider.middle, end: newPos.slider.end };

		let newState = Object.assign({}, this.state, { search: searchchg, sliders : sliderchg });

		this.setState(newState);
	}

	onSliderChangeFrontage(key){
		let newPos = this.calcNewSliderValues(key, this.state.search.frontage);
		// create a new object for the search element

		let searchchg = this.state.search;
		searchchg.frontage = {
			current : { low : newPos.search.low, high : newPos.search.high, },
			original : this.state.search.frontage.original,
			step : this.state.search.frontage.step,
		};

		// create a new object for the slider element
		let sliderchg = this.state.sliders;
		sliderchg.frontage = { start: newPos.slider.start, middle: newPos.slider.middle, end: newPos.slider.end };

		let newState = Object.assign({}, this.state, { search: searchchg, sliders : sliderchg });

		this.setState(newState);
	}

	calcNewSliderValues(cSlide, cValues) {
		// work out our constant values
		let w = cValues.original.high - cValues.original.low;  // work out our shifted highpoint to determine value of 100%
		let x = w / 100; // work out what 1% of the highpoint value is
		let y = w / cValues.step; // work out a constant for the step

		// calculate new slider position values fixed to steps
		let newSlideStart = this.sliderPositionFormula( cSlide[0] ,x ,y );
		let newSlideMiddle = this.sliderPositionFormula( ( cSlide[0] + cSlide[1] ) ,x ,y ) - newSlideStart;
		let newSlideEnd = 100 - ( newSlideStart + newSlideMiddle );

		// calculate our new display values fixed to steps
		let newValueLow = this.sliderValueFormula( newSlideStart , x, cValues.step ) + cValues.original.low;
		let newValueHigh = this.sliderValueFormula( (newSlideStart + newSlideMiddle) , x, cValues.step ) + cValues.original.low;

		// structure response
		let newValues = {
			search : {
				low : newValueLow,
				high : newValueHigh,
			},
			slider : {
				start : newSlideStart,
				middle : newSlideMiddle,
				end : newSlideEnd,
			}
		};
		return newValues;
	}

	sliderPositionFormula (a, x, y) {
		if (x < 1) {
			//when x < 1 it creates an issue with rounding the numbers, so we multiple and divide by 10 in places to account for this
			return ( ( Math.round( (((a * x) / y) * 10) ) /10 ) * y) / x;
		} else {
			return (Math.round(((a * x) / y)) * y) / x;
		}
	}

	sliderValueFormula (a, x, z) {
		return ( Math.round(((a * x) / z)) * z );
	}

	sliderSearchClick() {
		// apply a new search filter to the list of available lots
		// get a list of searchable lots within each stage
		let stagechg = this.searchLots(this.state.stages, this.state.search.frontage.current, this.state.search.area.current, LFSConstants.ACTIVE_STATES);
		// apply the current filter ordering
		let newArray = this.applyLotOrdering(stagechg, this.state.filterby);

		let newState = Object.assign({}, this.state, { filteredlots: newArray, displaysearchresults: true });

		this.setState(newState);

		setTimeout(() => {
			document.querySelector('#LFSS-Search').scrollIntoView({behavior: "smooth"});
		}, 100)
	}

	searchLots(stages, frontage, area) {
		let flots = stages ;

		// filter the array again to apply frontage restrictions.
		flots = flots.filter((lot) => {
			if(lot.frontage >= frontage.low && lot.frontage <= frontage.high) {
				return lot;
			} else {
				return null;
			}
		});
		// filter the array again to apply area restrictions.
		flots = flots.filter((lot) => {
			if(lot.area >= area.low && lot.area <= area.high){
				return lot;
			} else {
				return null;
			}
		});
		// return list of filtered lots
		return flots;
	}

	applyLotOrdering(lots, order) {
		if (order.type === 'frontage') {
			if (order.order === 'asc') {
				return lots.slice().sort(this.ascFrontageCompare);
			} else {
				return lots.slice().sort(this.descFrontageCompare);
			}
		}
		else if (order.type === 'area') {
			if (order.order === 'asc') {
				return lots.slice().sort(this.ascAreaCompare);
			} else {
				return lots.slice().sort(this.descAreaCompare);
			}
		}
		else if (order.type === 'price') {
			if (order.order === 'asc') {
				return lots.slice().sort(this.ascPriceCompare);
			} else {
				return lots.slice().sort(this.descPriceCompare);
			}
		}
	}

	ascAreaCompare(a, b){
		let comparison = 0;
		if (parseFloat(a.area) > parseFloat(b.area)) {
			comparison = 1;
		} else if (parseFloat(b.area) > parseFloat(a.area)) {
			comparison = -1;
		}
		return comparison;
	}

	descAreaCompare(a, b){
		let comparison = 0;
		if (parseFloat(a.area) < parseFloat(b.area)) {
			comparison = 1;
		} else if (parseFloat(b.area) < parseFloat(a.area)) {
			comparison = -1;
		}
		return comparison;
	}

	ascFrontageCompare(a, b){
		let comparison = 0;
		if (parseFloat(a.frontage) > parseFloat(b.frontage)) {
			comparison = 1;
		} else if (parseFloat(b.frontage) > parseFloat(a.frontage)) {
			comparison = -1;
		}
		return comparison;
	}

	descFrontageCompare(a, b){
		let comparison = 0;
		if (parseFloat(a.frontage) < parseFloat(b.frontage)) {
			comparison = 1;
		} else if (parseFloat(b.frontage) < parseFloat(a.frontage)) {
			comparison = -1;
		}
		return comparison;
	}

	ascPriceCompare(a, b){
		let comparison = 0;
		if (parseFloat(a.order_price) > parseFloat(b.order_price)) {
			comparison = 1;
		} else if (parseFloat(b.order_price) > parseFloat(a.order_price)) {
			comparison = -1;
		}
		return comparison;
	}

	descPriceCompare(a, b){
		let comparison = 0;
		if (parseFloat(a.order_price) < parseFloat(b.order_price)) {
			comparison = 1;
		} else if (parseFloat(b.order_price) < parseFloat(a.order_price)) {
			comparison = -1;
		}
		return comparison;
	}


	sliderResetClick() {
		// need to do a reset of slider values back to the original start points and do a new search on the lots
		// create a reset version search state  (basically this is a copy of the original values into the current values)
		let searchchg = {
			frontage: {
				current: this.state.search.frontage.original,
				original: this.state.search.frontage.original,
				step: this.state.search.frontage.step,
			},
			area: {
				current: this.state.search.area.original,
				original: this.state.search.area.original,
				step: this.state.search.area.step,
			}
		};
		// create a reset version slider state  (basically these are the hardcoded values for start, middle and end)
		let sliderchg = { frontage: { start: 0, middle: 100, end: 0 }, area: { start: 0, middle: 100, end: 0 } };
		// get a list of searchable lots within each stage
		let stagechg = this.searchLots(this.state.stages, this.state.search.frontage.original, this.state.search.area.original, LFSConstants.ACTIVE_STATES);
		// apply the current filter ordering
		let newArray = this.applyLotOrdering(stagechg, this.state.filterby);

		let newState = Object.assign({}, this.state, { search: searchchg, sliders : sliderchg, filteredlots: newArray });

		this.setState(newState);
	}

	updateWithAvailableLots( astates ) {
		return function (stg, idx) {
			let lots = stg.lots;
			let alots = lots.filter((lot) =>
			{
				if (astates.indexOf(lot.status) !== -1) {
					return lot;
				} else {
					return null;
				}
			});
			stg.available_lots = alots.length;
			return stg;
		}
	}

	onClose() {
		// the close buttons effectively resets the whole search, switches off display, empties the lot array and resets the ordering filter
		let newState = Object.assign({}, this.state, { displaysearchresults: false, filteredlots: null, filterby: { type: 'frontage', order: 'asc' } });

		this.setState(newState);
	}

	onOrderFrontage() {
		let newFilter = null;
		// change our filtering state
		if (this.state.filterby.type === 'frontage') {
			if (this.state.filterby.order === 'asc') {
				newFilter = { type: 'frontage', order: 'desc' }
			} else {
				newFilter = { type: 'frontage', order: 'asc' }
			}
		} else {
			newFilter = { type: 'frontage', order: 'asc' }
		}
		// apply the new filtering state to the filtered lots array to re-order it
		let newArray = this.applyLotOrdering(this.state.filteredlots, newFilter);
		let newState = Object.assign({}, this.state, { filterby: newFilter, filteredlots: newArray });

		this.setState(newState);
	}

	onOrderArea() {
		let newFilter = null;
		// change our filtering state
		if (this.state.filterby.type === 'area') {
			if (this.state.filterby.order === 'asc') {
				newFilter = { type: 'area', order: 'desc' }
			} else {
				newFilter = { type: 'area', order: 'asc' }
			}
		} else {
			newFilter = { type: 'area', order: 'asc' }
		}
		// apply the new filtering state to the filtered lots array to re-order it
		let newArray = this.applyLotOrdering(this.state.filteredlots, newFilter);
		let newState = Object.assign({}, this.state, { filterby: newFilter, filteredlots: newArray });

		this.setState(newState);
	}

	onOrderPrice() {
		let newFilter = null;
		// change our filtering state
		if (this.state.filterby.type === 'price') {
			if (this.state.filterby.order === 'asc') {
				newFilter = { type: 'price', order: 'desc' }
			} else {
				newFilter = { type: 'price', order: 'asc' }
			}
		} else {
			newFilter = { type: 'price', order: 'asc' }
		}
		// apply the new filtering state to the filtered lots array to re-order it
		let newArray = this.applyLotOrdering(this.state.filteredlots, newFilter);
		let newState = Object.assign({}, this.state, { filterby: newFilter, filteredlots: newArray });

		this.setState(newState);
	}


	render() {
		if (typeof this.state.search.area !== "undefined") {
			return (
				<div className="Land-Search-Container" id="LFSS-Search">
					<h1 className="LFS-Search-Title">Search for Land</h1>
					<div className="LFSS-Search-Box">
						<div className="Column-Thirds-Left">
							<div className="fl-l">Land Size</div><div className="fl-r2"> {this.state.search.area.current.low}m<sup>2</sup> to {this.state.search.area.current.high}m<sup>2</sup></div>
							<div className="lfss-slider">
								<MultiSlider colors={["#424242", "#ffffff"]} values={[this.state.sliders.area.start, this.state.sliders.area.middle, this.state.sliders.area.end]} onChange={this.onSliderChangeArea} handleSize={13} height={30} handleInnerDotSize={0} />
							</div>
						</div>
						<div className="Column-Thirds-Left">
							<div className="fl-l">Frontage</div><div className="fl-r"> {this.state.search.frontage.current.low}m to {this.state.search.frontage.current.high}m</div>
							<div className="lfss-slider">
								<MultiSlider colors={["#424242", "#ffffff"]} values={[this.state.sliders.frontage.start, this.state.sliders.frontage.middle, this.state.sliders.frontage.end]} onChange={this.onSliderChangeFrontage} handleSize={13} height={30} handleInnerDotSize={0} />
							</div>
						</div>
						<div className="Column-Thirds-Right">
							<LFSSButton onClick={this.sliderResetClick}>Reset</LFSSButton>
							<LFSSButton onClick={this.sliderSearchClick}>Search</LFSSButton>
						</div>
					</div>
					<div className={`LFSS-Results ${this.state.displaysearchresults}`}>
						<CloseButton className="lfss-close" path="#Close" onClick={this.onClose} />
						<div className="Column-Filter-Left">
							<OrderingButton className="lfsb-orderbutton" btype="frontage" target="_parent" filterby={this.state.filterby} onClick={this.onOrderFrontage}>Frontage</OrderingButton>
							<OrderingButton className="lfsb-orderbutton" btype="area" target="_parent" filterby={this.state.filterby} onClick={this.onOrderArea}>Land Size</OrderingButton>
							<OrderingButton className="lfsb-orderbutton" btype="price" target="_parent" filterby={this.state.filterby} onClick={this.onOrderPrice}>Price</OrderingButton>
						</div>
						<Clr/>
						<DisplayAllLots state={this.state.filteredlots} lots={this.state}></DisplayAllLots>
					</div>
				</div>
			)
		} else {
			return null;
		}
	}
}

export default LandSearch;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/LandSearch.js
 **/